import React, { useEffect, useState } from "react";
import axios from "axios";

export default function AdminBookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false); // loading for table
  const [processingId, setProcessingId] = useState(null); // tracks approve/reject in progress

  useEffect(() => {
    loadPendingBookings();
  }, []);

  const loadPendingBookings = async () => {
    setLoading(true);
    try {
      const res = await axios.get("http://localhost:8080/api/booking/admin/pending");
      setBookings(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load bookings");
    } finally {
      setLoading(false);
    }
  };

  const approve = async (id) => {
    setProcessingId(id);
    try {
      await axios.put(`http://localhost:8080/api/booking/admin/approve/${id}`);
      await loadPendingBookings();
    } catch (err) {
      console.error(err);
      alert("Failed to approve booking");
    } finally {
      setProcessingId(null);
    }
  };

  const reject = async (id) => {
    setProcessingId(id);
    try {
      await axios.put(`http://localhost:8080/api/booking/admin/reject/${id}`);
      await loadPendingBookings();
    } catch (err) {
      console.error(err);
      alert("Failed to reject booking");
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <div className="container mt-4">
      <h2>📋 Pending Bookings</h2>

      {loading ? (
        <p>Loading bookings...</p>
      ) : bookings.length === 0 ? (
        <p>No pending bookings</p>
      ) : (
        <table className="table table-bordered mt-3">
          <thead className="table-dark">
            <tr>
              <th>User ID</th>
              <th>Room ID</th>
              <th>Email</th>
              <th>Phone</th>

              <th>Check-In</th>
              <th>Check-Out</th>
              <th>Total</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {bookings.map((b) => (
              <tr key={b.id}>
                <td>{b.userId}</td>
                <td>{b.roomId}</td>
                <td>{b.userEmail}</td>
                <td>{b.userPhone}</td>

                <td>{b.checkIn}</td>
                <td>{b.checkOut}</td>
                <td>₹{b.totalPrice}</td>
                <td>
                  <button
                    className="btn btn-success btn-sm me-2"
                    onClick={() => approve(b.id)}
                    disabled={processingId === b.id}
                  >
                    {processingId === b.id ? "Processing..." : "Approve"}
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => reject(b.id)}
                    disabled={processingId === b.id}
                  >
                    {processingId === b.id ? "Processing..." : "Reject"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
